import React, { useState, useRef, useLayoutEffect, MutableRefObject } from 'react';
import { useDraggable, ISpringInterface, IDraggableBounds } from './useDraggable';
import { useLatest } from 'utils/Index';

export const useDraggableSlider = (
  scale: number = 1,
) => {
  const backgroundRef = useRef<HTMLDivElement>(null);
  const contentRef = useRef<HTMLDivElement>(null);

  const [range, setRange] = useState(0);
  const latestRange = useLatest(range);

  useLayoutEffect(() => {
    const updateDraggablePaneDimensions = () => {
      const backgroundProps = backgroundRef.current.getBoundingClientRect();
      const contentProps = contentRef.current.getBoundingClientRect();

      const width = contentProps.width - backgroundProps.width - backgroundProps.left;
      const newRange = width * -1;

      setRange(newRange < 0 ? newRange : 0);
    };

    updateDraggablePaneDimensions();

    // Setup event listeners on initial mount to keep the  dimensions of the draggable pane updated
    window.addEventListener("resize", updateDraggablePaneDimensions);

    return () => {
      window.removeEventListener("resize", updateDraggablePaneDimensions);
    };
  }, []);

  const bounds: IDraggableBounds = {
    y: [0, 0],
    x: [latestRange.current / scale, 0],
  };

  const [bind, isBeingDragged, xPosition, xVelocity] = useDraggable(range, bounds);

  let returnValues: [MutableRefObject<any>, MutableRefObject<any>, number, (...args: any[]) => any, boolean, any, ISpringInterface];
  returnValues = [backgroundRef, contentRef, range, bind, isBeingDragged, xPosition, xVelocity];

  return returnValues;
};

